import type { PropsWithChildren } from "react";

interface HeadingProps extends PropsWithChildren {
	level: number;
}

export const BodyHeading = ({ children, level }: HeadingProps) => {
	if (level === 1) {
		return <h2>{children}</h2>;
	}
	if (level === 2) {
		return <h3>{children}</h3>;
	}
	if (level === 3) {
		return <h4>{children}</h4>;
	}
	if (level === 4) {
		return <h5>{children} </h5>;
	}

	return <h6>{children}</h6>;
};
